import React from "react"
import { TextTag } from "../../atoms"
import {
  BROWSER_INFO_MSG,
  TERMS_LINK,
  TERMS,
  PRIVACY_POLICY_LINK,
  PRIVACY_POLICY,
  AND,
} from "../../constants/messages"

const SignUpSignInFooter = (props) => {
  return (
    <p className="browser-msg">
      <TextTag textType="smallTextPrimary">
        {BROWSER_INFO_MSG}
        <a href={TERMS_LINK} target="_blank">
          <TextTag textType="linkText" className="terms-and-policy">
            {" "}
            {TERMS}
          </TextTag>
        </a>
        {AND}
        <a href={PRIVACY_POLICY_LINK} target="_blank">
          <TextTag textType="linkText" className="terms-and-policy">
            {PRIVACY_POLICY}
          </TextTag>
        </a>
      </TextTag>
    </p>
  )
}

export default SignUpSignInFooter
